var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakephoto2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55016 11.4416C10.8434 11.4416 11.8918 10.3932 11.8918 9.09997C11.8918 7.8067 10.8434 6.7583 9.55016 6.7583C8.25689 6.7583 7.2085 7.8067 7.2085 9.09997C7.2085 10.3932 8.25689 11.4416 9.55016 11.4416Z",
    stroke: "#292D32",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8751 16.8334C13.8751 14.8917 11.9418 13.3083 9.5501 13.3083C7.15843 13.3083 5.2251 14.8834 5.2251 16.8334",
    stroke: "#292D32",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 10.4167C17.5001 14.7917 13.9584 18.3333 9.58341 18.3333C5.20841 18.3333 1.66675 14.7917 1.66675 10.4167C1.66675 6.04167 5.20841 2.5 9.58341 2.5C10.6751 2.5 11.7167 2.71666 12.6667 3.11666C12.5584 3.44999 12.5001 3.8 12.5001 4.16667C12.5001 4.79167 12.6751 5.38333 12.9834 5.88333C13.1501 6.16666 13.3667 6.42498 13.6167 6.64164C14.2001 7.17498 14.9751 7.5 15.8334 7.5C16.2001 7.5 16.5501 7.44165 16.8751 7.32498C17.2751 8.27498 17.5001 9.325 17.5001 10.4167Z",
    stroke: "#292D32",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 4.16659C19.1667 4.43325 19.1333 4.69158 19.0667 4.94158C18.9917 5.27491 18.8583 5.59992 18.6833 5.88325C18.2833 6.55825 17.6417 7.08323 16.875 7.3249C16.55 7.44157 16.2 7.49992 15.8333 7.49992C14.975 7.49992 14.2 7.17489 13.6167 6.64156C13.3667 6.42489 13.15 6.16658 12.9833 5.88325C12.675 5.38325 12.5 4.79159 12.5 4.16659C12.5 3.79992 12.5583 3.44991 12.6667 3.11658C12.825 2.63324 13.0917 2.19994 13.4417 1.8416C14.05 1.2166 14.9 0.833252 15.8333 0.833252C16.8167 0.833252 17.7083 1.25827 18.3083 1.9416C18.8417 2.53327 19.1667 3.31659 19.1667 4.16659Z",
    stroke: "#292D32",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0749 4.1499H14.5916",
    stroke: "#292D32",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.93335V5.42501",
    stroke: "#292D32",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakephoto2);
export default __webpack_public_path__ + "static/media/takephoto (2).bc38babf81a24a6f402c6fd99720d7e4.svg";
export { ForwardRef as ReactComponent };